import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { format, formatISO, isBefore, parse } from "date-fns";
import Alert from "@shared/v2/Alert";
import Button from "@shared/v2/Button";
import DatePicker from "@shared/v2/DatePicker";
import Modal from "@shared/v2/Modal";
import { ClockFiveSolidV6 } from "@shared/v2/Icomoon";
import { updatePost } from "../../reducers/websiteReducer/websiteReducer";

const PublishDateModal = ({ onClose, post }) => {
  const [error, setError] = useState("test");
  const [date, setDate] = useState("");
  const dispatch = useDispatch();
  const isBeforeNow = date ? isBefore(date, new Date()) : false;

  useEffect(() => {
    if (post) {
      setError("");
      setDate(post.dateToPublish);
    }
  }, [post]);

  return (
    <Modal
      show={Boolean(post)}
      onHide={onClose}
      closeOnEscape={false}
      dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
      contentClassName="tw-max-w-[440px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[24px]"
    >
      <Modal.Header title="Set Publish Date" closeButton />
      <Modal.Body className="tw-flex tw-flex-col tw-gap-[24px]">
        <DatePicker
          value={date ? format(date, "MM/dd/yyyy hh:mm a") : null}
          placeholder="MM/DD/YYYY"
          label="Publish Date and Time"
          onChange={(d) => {
            if (d && d.includes(" ")) setDate(formatISO(parse(d, "MM/dd/yyyy hh:mm a", new Date())));
            else if (d) setDate(formatISO(parse(d, "MM/dd/yyyy", new Date())));
            else setDate(null);
          }}
          enableTimePicker
          startTimeEnabled
          startTimeClassName="tw-hidden"
        />
        {error && <Alert variant="error" text={error} />}
      </Modal.Body>
      <Modal.Footer className="tw-flex tw-justify-between tw-gap-[8px]">
        <Button size="medium" schema="tertiary" onClick={onClose}>
          Cancel
        </Button>
        <Button
          className="tw-inline-flex tw-items-center tw-gap-[8px]"
          size="medium"
          onClick={() => {
            setError("");
            dispatch(
              updatePost({
                ...post,
                isPublished: isBeforeNow,
                dateToPublish: isBeforeNow ? null : date,
                datePublished: isBeforeNow ? date : null,
              }),
            ).then((state) => {
              if (state.error && state.payload.content) setError("Post content cannot be empty");
              if (state.error && typeof state.payload === "string") setError(state.payload);
              if (!state.error) onClose();
            });
          }}
          disabled={!date}
        >
          {isBeforeNow ? (
            "Publish"
          ) : (
            <>
              Schedule <ClockFiveSolidV6 />
            </>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

PublishDateModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  post: PropTypes.shape(),
};

PublishDateModal.defaultProps = {
  post: null,
};

export default PublishDateModal;
